module.exports = __webpack_public_path__ + "static/media/noimage.770127d8.svg";